import { isImageFileName } from './chatFiles'

export function buildQuoteFromMessage(msg, { selectedContact } = {}) {
  if (!msg) return null
  const isSelf = msg.sender === 'me'
  let senderName = 'Member'
  if (isSelf) {
    senderName = 'You'
  } else if (selectedContact?.isGroup) {
    senderName = msg.senderName || 'Member'
  } else if (selectedContact) {
    senderName = selectedContact.system_name || selectedContact.real_name || selectedContact.name || 'Member'
  } else {
    senderName = msg.senderName || 'Member'
  }

  return {
    id: msg.id,
    sender_id: msg.senderId,
    sender_name: senderName,
    message_type: msg.messageType,
    content: msg.messageType === 'file' ? (msg.fileName || msg.text) : msg.text,
    file_url: msg.fileUrl || null,
    is_image: msg.isImage || (msg.messageType === 'file' && isImageFileName(msg.fileName || msg.text)),
  }
}

export function mapReplyFromRow(row) {
  if (!row?.reply_to) return null
  return {
    id: row.reply_to.id || row.reply_to_id,
    sender_id: row.reply_to.sender_id,
    sender_name: row.reply_to.sender_name,
    message_type: row.reply_to.message_type,
    content: row.reply_to.content,
    file_url: row.reply_to.file_url,
    is_image: row.reply_to.is_image,
    content_masked: row.reply_to.content_masked,
  }
}

export function quotePreviewText(quote, { maxLen = 72 } = {}) {
  if (!quote) return ''
  if (quote.message_type === 'file') {
    if (quote.is_image) return '[Image]'
    const name = quote.content || 'File'
    return name.length > maxLen ? `${name.slice(0, maxLen)}…` : `[File] ${name}`
  }
  const text = String(quote.content || '').replace(/\s+/g, ' ').trim()
  if (!text) return '[Message]'
  return text.length > maxLen ? `${text.slice(0, maxLen)}…` : text
}
